import React from "react";
import "App.css";
import { Agentation } from "agentation";
import { AppRouter } from "components/elements/AppRouter";
import config from 'config/app-config';
import {routes} from 'routes';

function App() {
  return (
    <>
      <AppRouter
        basename={config.routeBaseName}
        routes={routes}
        defaultRedirect="/test-page"
      />
      {process.env.NODE_ENV === "development" && <Agentation />}
    </>
  );
}

export default App;
